// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2023-08-25T12:19:48+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  172009
//    Project:        484
//    Environment:    4517 - release/2023-08-25/r1
//    MD5:            3aa5e57790037ca3316139ff694ecb43
//    Signature:      eyJpdiI6InRhcG9Objd2RTBrTXQyYzZZNWhkUVE9PSIsInZhbHVlIjoiZWNKMlZydlhwXC9jUnBlK25cL2QrQmJrbTJSR1pISXhxYXI0Qm1xUnkxQnlRazBCQlwvTFI3cmQxandKeGJrbXZrcDFaaTVcL0s3TStDVEw1VHhSVFdCTk02N0kxMzdSOFwvXC9uXC9rVlVlNEVpOVRLbTJUWDJYMVM4ZWN6dDJoVlRjVTBUZEwydEZLemh4a1Jad3hiTjdaVG9DNmlUSXpuOTUrR1htVFdWOHBNd29mV1wvY05HT2ZndFdGekpUV3lwK09yUTg4aHZ6QXBacXd3TVRQRXVCeCs0WjNyZWhScEZQY0tMdDhoXC9iRFM4RTM0N3NtckZwVjJrRFhsUlFzcGhFbHhGWDlSdnFPRzVJdVBoQThDUkozZHdKMFFrRmFcL2crUkJaV25wcVV5M0JuVk1pdVVuTWh1Ymt2OUZuZVY0Ymtna1k5T2pnOFpCeHg1NDZINlNRTlR1T21yMGtyVnJqMzhFYUlrNmNqWTlGVjBVKzRkZ2dlcmdWTVBnZzJ0em4wKzhINWpQcjN4ZDRcL29LeTZDT2RiQWhXbHJ3PT0iLCJtYWMiOiI3MDI2YmRiYWQzOGYyOTZiNDI2MDIyMjRhYzIxYTQwNWM4OGFiNDBlNDNkMmJkMzA1Y2Y4ZjJmMDJkNTIxOGU3In0=
// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2022-12-20T17:02:18+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  165532
//    Project:        484
//    Environment:    3120 - master
//    MD5:            daa78c9eaffa06abe37577d7be7d56fd
//    Signature:      eyJpdiI6IjVtTTAyKzFKRUI4Vll5T2xHYXlwTkE9PSIsInZhbHVlIjoieTA2ZHpENnN0cXhiN2xuZXlBVEZyMG8wQ2k2VEdJcFhZeVhyTFhhNkROblRNNEpSYmJkdWRrU3NFUng5dVJrRE1oUWpcL0d2MVF6Y3ZnajI3RjUwa0pVUXZVV3pTNEU0eVVYK0FKR3ZmSWpzSURvZzU4OUJUWGdPVmlNU0I2V0hXZzRycnJKTWppcVwvSlJaRmdmaUpYcHhSQUtBM3lWSkxiUmU3dE5CdVRlQjdnTHY2TEZYRDRGSnNyZTFvcDJnWlZaXC9MdnFDeVIzS3F0VDczRVZBNkN5djBMenhlNW9KYUgxWjUwUVlvNStOSkpPSGp3SGYzWDF3Q3VJVFVTSkR2eUZYMktxS05MZEVZSElTNFpuT2Z0dzFQckRLNnRvbzhQNTJIUlwvaStzQnJYNHROY2pCN0VxUWdjWG1HNUIzVUJuSkptV1VITHk1XC9ISlZ4Q3h4V2VHWExlN29xbURpYkJTT0F1NEdWaGFlXC8zM0NFWTk0cjBEdnhWbUtENmJBbWV1OEFNT0xrRHkzNnRGN3NaQ3lNR0tvQT09IiwibWFjIjoiOWE3OGMxNmM2NzZmMDU4ZWI3MmMyNTBmOGMwMTYxNTcyMWFhMmZlOWRhZDBhZTJjODY4YjQwYTliZmFjNTFlZiJ9
$( document ).ready(function() {

	var highlightLines = 4;

	$('.collection--description').each(function(){
		lineHeight = parseInt($(this).css('line-height'), 10);
		if ($(this).height() > lineHeight * highlightLines) {
			$(this).after('<div class="highlight-seemore seemore-closed">^</div>')
		}
		$(this).height(lineHeight * highlightLines).addClass('highlight-closed');
		$(this).css('overflow','hidden');
	});
	

	$('body').on('click','.highlight-seemore.seemore-closed', function(){
		target = $(this).prev();
		$(target).animate({
			height: $(target).get(0).scrollHeight
		}, 500, function(){
			$(this).removeClass('highlight-closed').addClass('highlight-open');
		});
        $(this).removeClass('seemore-closed').addClass('seemore-open');
	});
  
  
	$('body').on('click','.highlight-seemore.seemore-open', function(){
		target = $(this).prev();
		lineHeight = parseInt($(target).css('line-height'), 10);
		$(target).animate({
			height: lineHeight * highlightLines
		}, 500, function(){
			$(this).removeClass('highlight-open').addClass('highlight-closed');
		});
        $(this).removeClass('seemore-open').addClass('seemore-closed');
	});
  
	
});